import { createRef } from "react";
import {
  dataStatus,
  fileTags,
  actions,
  processDefaultTableSortFile,
} from "../../publicDictionaryValues";
import reasonEditDefaultIcon from "../../../assets/image/reasonEditIcon.png";
import ProcessBase from "../../commonComponents/processBase/index";
import createSupportingFileService from "../../../service/supportingFile/createSupportingFileService";
import CompleteStepBusinessType from "../../../service/stepBase/completeStepBusinessType";
import StepService from "../../../service/stepBase/StepService";
const procedureReplaceFileRef = createRef();

export default class SupportingFileProcess extends ProcessBase {
  constructor(props: any) {
    super(props);
    this.setGlobalVariables();
    this.initProcedureFileState();
    // @ts-ignore
    this.supportingFileStepID = null;
    // @ts-ignore
    this.isSubmitComplete = undefined;
    // @ts-ignore
    this.isApprovePending = undefined;
    // @ts-ignore
    this.isApproveComplete = undefined;
    // @ts-ignore
    this.isRevisePending = undefined;
    // @ts-ignore
    this.isReviseComplete = undefined;
  }

  /**
   * Set Component Global Variables
   */
  setGlobalVariables = () => {
    // @ts-ignore
    this.initSavedInSectionState = {
      savedInRadioValue: null,
    };

    // @ts-ignore
    this.initServerPathSectionState = {
      serverPathValue: null,
    };

    // @ts-ignore
    this.primitiveServerPathSectionState = JSON.parse(
      JSON.stringify(this.initServerPathSectionState)
    );

    // @ts-ignore
    this.initProcedureFileTableState = [];

    // @ts-ignore
    this.initSupportingTableData = [];

    // @ts-ignore
    this.initSupportingTableState = {
      returnedList: [],
      fileTableJbStatus: null,
      fileTableReturned: false,
      fileTableReturnReasonValue: null,
      fileTableReasonStatus: null,
      attachment: {},
    };
  };

  /**
   * Init Component State
   */
  initProcedureFileState = () => {
    this.state = {
      pageState: {
        flowCategoryID: null,
        requestByID: null,
        requestByName: null,
        receiveDate: null,
        procedureID: null,
        procedureStepID: null,
        procedureStatus: null,
        isSaveDisabled: false,
        isCancelDisabled: false,
        isSubmitDisabled: false,
        isRejectDisabled: false,
        procedureFolder: {},
        rejectReason: null,
        rejectStatus: null,
        currentRole: null,
        actionName: null,
        loading: false,
        procedureStepStatus: null,
        uploadSupportingFileNum: 0,
        supportingFileNum: 0,
        procedureNote: "",
      },
      initTableDate: {},
      // @ts-ignore
      savedInSectionState: this.initSavedInSectionState,
      // @ts-ignore
      serverPathSectionState: this.initServerPathSectionState,
      procedureFileTableState: [],
      isReturnReasonLogOpen: false,
      fileTableData: [],
      supportingTableData: [],
      taskInfoData: {},
      procedureInfoData: {},
      procedureFileData: {},
      // @ts-ignore
      supportingFileData: this.initSupportingTableState,
      shareTaskData: {},
      ppoList: [],
      isMount: false,
      jbProcedureSavedIn: null,
    };
  };

  /**
   * set saved in and client server path data in procedure file section
   * @param {*} result
   */
  setSavedInServerPathState = (result: any) => {
    this.setState({
      savedInSectionState: {
        savedInRadioValue: result.procedureFolder?.procedureSaveInCategoryID || null,
      },
      serverPathSectionState: {
        serverPathValue:
          result.procedureFolder !== null ? result.procedureFolder.clientServerPath : "",
      },
    });
  };

  /* function about adjust data when get data from api */
  handleDataNull = (file: any, key: any) => {
    if (file[key] === null) {
      if (key === "procedureFileID") {
        return 0;
      } else {
        return null;
      }
    } else {
      return file[key];
    }
  };

  /* get supporting file return reason log */
  getFileReturnReasonLog = (folder: any, key: any) => {
    const returnReasonLog: any[] = [];
    const historyList = folder.stepHistoryList;
    historyList.sort((a: any, b: any) => {
      return b.modifiedDate.localeCompare(a.modifiedDate);
    });
    historyList.forEach((stepItem: any, index: any) => {
      stepItem.actionID === actions.return &&
        stepItem.supportingFiles.forEach((fileItem: any, index: any) => {
          if (
            fileItem.fileKey === key &&
            fileItem.dataStatusID === dataStatus.return &&
            fileItem.returnReason !== null
          ) {
            returnReasonLog.push({
              key: index,
              returnedBy: stepItem.auditedByName,
              returnDate: this._formateDate(stepItem.modifiedDate),
              returnReasonColumn: fileItem.returnReason,
            });
          }
        });
    });
    return returnReasonLog;
  };

  /* function set approve and return button disabled when init load page */
  handleReturnInitBtnDisabled = (procedureFile: any, status: any) => {
    // @ts-ignore
    return this.isRevisePage
      ? false
      : this.handleDataNull(procedureFile, "dataStatusID") === status;
  };

  handleSortFile = (result: any) => {
    return processDefaultTableSortFile(result.supportingFolder.supportingFiles, this._formateDate);
  };

  /**
   * set supporting file table data
   * @param {*} folder
   */
  setSupportingTableData = (result: any) => {
    const supportingFileList = this.handleSortFile(result);
    let isRevise = false;
    if (
      result.workflowProcessStepInfo !== null &&
      result.workflowProcessStepInfo.annotations.length !== 0
    ) {
      isRevise =
        result.workflowProcessStepInfo.annotations.find((item: any) => item.name === "IsRevise")
          .value === "1";
    }
    supportingFileList.forEach((supportingFile) => {
      const isReviseOrNoOldFile =
        this.handleDataNull(supportingFile, "oldFileID") === null || !isRevise;
      const isDeleteOrNoOldFile =
        this.handleDataNull(supportingFile, "oldFileID") === null ||
        this.handleDataNull(supportingFile, "fileTagID") === fileTags.deleted;
      if (!supportingFile.isDelete) {
        const lineId = this._generateGUID();
        const uploadedDate = this.handleDataNull(supportingFile, "uploadedDate");
        const approvedDate = this.handleDataNull(supportingFile, "approvedDate");
        // @ts-ignore
        this.supportingTableData.push({
          data: [
            { name: "lineId", value: lineId },
            {
              name: "fileId",
              value: isReviseOrNoOldFile
                ? this.handleDataNull(supportingFile, "fileID")
                : this.handleDataNull(supportingFile, "oldFileID"),
            },
            {
              name: "supportingFileID",
              value: this.handleDataNull(supportingFile, "supportingFileID"),
            },
            {
              name: "supportingFileStepID",
              value: this.handleDataNull(supportingFile, "supportingFileStepID"),
            },
            {
              name: "fileKey",
              value: this.handleDataNull(supportingFile, "fileKey"),
            },
            {
              name: "fileName",
              value: isReviseOrNoOldFile
                ? this.handleDataNull(supportingFile, "fileName")
                : this.handleDataNull(supportingFile, "oldFileName"),
              tagValue: this.handleDataNull(supportingFile, "fileTagID"),
            },
            {
              name: "uploadedDate",
              value: this._formateDate(uploadedDate),
            },
            {
              name: "uploadByName",
              value: this.handleDataNull(supportingFile, "uploadByName"),
            },
            {
              name: "uploadById",
              value: this.handleDataNull(supportingFile, "uploadBy"),
            },
            {
              name: "approveDate",
              value: this._formateDate(approvedDate),
            },
            {
              name: "approveTime",
              value: approvedDate,
            },
            {
              name: "note",
              value: this.handleDataNull(supportingFile, "note"),
              isDisabled: false,
            },
            {
              name: "proposedChange",
              value: this.handleDataNull(supportingFile, "proposedChangeTagID"),
            },
            {
              name: "status",
              value: this.handleDataNull(supportingFile, "dataStatusID"),
            },
            {
              name: "returnReason",
              value: this.handleDataNull(supportingFile, "returnReason"),
              isDisabled: this.handleDataNull(supportingFile, "returnReason") === null,
              isShowReasonLog:
                this.getFileReturnReasonLog(result.supportingFolder, supportingFile.fileKey)
                  .length > 0,
              reasonLog: this.getFileReturnReasonLog(
                result.supportingFolder,
                supportingFile.fileKey
              ),
            },
            {
              name: "attachment",
              value: this.handleDataNull(supportingFile, "attachmentName"),
              fileId: this.handleDataNull(supportingFile, "attachmentFileID"),
              link: "#JavaScript:;",
              isDisabled: false,
            },
            {
              name: "newVersion",
              value: isDeleteOrNoOldFile ? null : this.handleDataNull(supportingFile, "fileName"),
              fileId: isDeleteOrNoOldFile ? null : this.handleDataNull(supportingFile, "fileID"),
              link: "#JavaScript:;",
            },
            {
              name: "previousStatus",
              value: this.handleDataNull(supportingFile, "dataStatusID"),
            },
            {
              name: "previousFileTag",
              value: this.handleDataNull(supportingFile, "fileTagID"),
            },
            {
              name: "isReviewed",
              value: this.handleDataNull(supportingFile, "isReviewed"),
            },
          ],
          checked: false,
          isApproveDisabled: this.handleReturnInitBtnDisabled(supportingFile, dataStatus.approval),
          isReturnDisabled: this.handleReturnInitBtnDisabled(supportingFile, dataStatus.return),
          isReturned: this.handleReturnInitBtnDisabled(supportingFile, dataStatus.return),
          isError: false,
          replaceRef: procedureReplaceFileRef,
          attachmentEditIcon: reasonEditDefaultIcon,
          isDelete: false,
          isUpdate: false,
        });
      }
    });
  };

  /**
   * set supporting file section data
   * @param {*} result
   */
  setSupportingFileData = (result: any) => {
    // @ts-ignore
    this.supportingFileStepID = result.supportingFolder.supportingFileStepID;
    this.setSupportingTableData(result);
    this.setState({
      // @ts-ignore
      supportingTableData: this.supportingTableData,
      isMount: true,
    });
    // @ts-ignore
    this.supportingTableData.forEach((item: any) => {
      // @ts-ignore
      this.initSupportingTableData.push({
        data: JSON.parse(JSON.stringify(item.data)),
        checked: item.checked,
        isApproveDisabled: item.isApproveDisabled,
        isReturnDisabled: item.isReturnDisabled,
        isReturned: item.isReturned,
        isError: item.isError,
        replaceRef: item.replaceRef,
        attachmentEditIcon: reasonEditDefaultIcon,
        isDelete: false,
        isUpdate: false,
      });
    });
  };

  /**
   * set procedure file section data
   * @param {*} result
   */
  setProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      this.setProcedureTableData(result.procedureFolder);
      this.setSavedInServerPathState(result);
      this.setState({
        // @ts-ignore
        fileTableData: this.procedureTableData,
        jbProcedureSavedIn: result.procedureFolder?.jbProcedureSaveIn || null,
      });
    }
  };

  _getFlowDataSuccess = (result: any) => {
    const { procedureStepStatus } = result;

    StepService.setStepInterfaceMergePayload(result, {
      isHistorical: procedureStepStatus === "Complete",
      isShareTaskProcess: false,
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    this.getInitData(
      createSupportingFileService.getCreateSupportingFileStepItem,
      "Get Supporting Files Failed",
      undefined,
      result,
      StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.taskInfo.settingKey])
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get Supporting Files Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };
    createSupportingFileService.getFlowStepData(
      param,
      this._getFlowDataSuccess,
      this._getFlowDataFailed
    );
  };

  componentDidMount() {
    this.getFlowData();
  }

  updateSupportingFileNum = async (num1: any, num2: any) => {
    await new Promise((resolve) => {
      this.setState(
        (prevState: any) => ({
          pageState: {
            ...prevState.pageState,
            loading: true,
            supportingFileNum: num1,
            uploadSupportingFileNum: num2,
          },
        }),
        // @ts-ignore
        resolve
      );
    });
  };

  /* function about get data from procedure file table */
  returnFileDataValue = (name: any, index: any, ref: any) => {
    const procedureFileData = ref.current.getDataList();
    let deleteList = ref.current.getDeleteList();
    let combineDatalist = procedureFileData.concat(deleteList);
    return combineDatalist[index].data.find((item: any) => item.name === name);
  };

  /* function about return submit data to use in integrate trigger api */
  handleReturnSubmitData = (
    actionID: any,
    actionName: any,
    pageProcedureRef: any,
    approvePageRef: any
  ) => {
    const fileDtos: any[] = [];
    if (pageProcedureRef.current !== null) {
      const procedureFileData = pageProcedureRef.current.getDataList();
      let deleteList = pageProcedureRef.current.getDeleteList();
      let combineDatalist = procedureFileData.concat(deleteList);
      combineDatalist.forEach((item: any, index: any) => {
        const replaceUserId = this.returnFileDataValue(
          "replaceUserId",
          index,
          pageProcedureRef
        )?.value;
        const replaceUserName = this.returnFileDataValue(
          "replaceUserName",
          index,
          pageProcedureRef
        )?.value;
        fileDtos.push({
          fileID:
            this.returnFileDataValue("newVersion", index, pageProcedureRef).fileId === null
              ? this.returnFileDataValue("fileId", index, pageProcedureRef).value
              : this.returnFileDataValue("newVersion", index, pageProcedureRef).fileId,
          createdDate: this.returnFileDataValue("uploadedDate", index, pageProcedureRef).value,
          uploadBy:
            replaceUserId && replaceUserName
              ? replaceUserId
              : this.returnFileDataValue("uploadById", index, pageProcedureRef).value,
          uploadByName:
            replaceUserId && replaceUserName
              ? replaceUserName
              : this.returnFileDataValue("uploadByName", index, pageProcedureRef).value,
          fileName:
            this.returnFileDataValue("newVersion", index, pageProcedureRef).value === null
              ? this.returnFileDataValue("fileName", index, pageProcedureRef).value
              : this.returnFileDataValue("newVersion", index, pageProcedureRef).value,
          fileKey: this.returnFileDataValue("fileKey", index, pageProcedureRef).value,
          dataStatusID: this.returnFileDataValue("status", index, pageProcedureRef).value,
          attachmentFileID: this.returnFileDataValue("attachment", index, pageProcedureRef).fileId,
          attachmentName: this.returnFileDataValue("attachment", index, pageProcedureRef).value,
          returnReason: this.returnFileDataValue("returnReason", index, pageProcedureRef).value,
          fileTagID: this.returnFileDataValue("fileName", index, pageProcedureRef).tagValue,
          supportingFileStepID: this.returnFileDataValue(
            "supportingFileStepID",
            index,
            pageProcedureRef
          ).value,
          supportingFileID: this.returnFileDataValue("supportingFileID", index, pageProcedureRef)
            .value,
          note: this.returnFileDataValue("note", index, pageProcedureRef).value,
          proposedChangeTagID:
            this.returnFileDataValue("proposedChange", index, pageProcedureRef) === undefined
              ? null
              : this.returnFileDataValue("proposedChange", index, pageProcedureRef).value,
          oldFileID:
            this.returnFileDataValue("newVersion", index, pageProcedureRef).fileId === null
              ? null
              : this.returnFileDataValue("fileId", index, pageProcedureRef).value,
          oldFileName:
            this.returnFileDataValue("newVersion", index, pageProcedureRef).value === null
              ? null
              : this.returnFileDataValue("fileName", index, pageProcedureRef).value,
          isReviewed:
            this.returnFileDataValue("isReviewed", index, pageProcedureRef).value === undefined
              ? null
              : this.returnFileDataValue("isReviewed", index, pageProcedureRef).value,
          isDelete: item.isDelete,
          isUpdate: item.isUpdate,
        });
      });
    }
    return {
      // @ts-ignore
      procedureId: this.procedureId,
      // @ts-ignore
      workflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      flowCategoryID: this.flowCategoryID,
      actionName: actionName,
      actionID: actionID,
      accountID: null,
      rejectReason:
        approvePageRef === undefined || approvePageRef.current === null
          ? null
          : approvePageRef.current.state.pageState.rejectReason,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      // @ts-ignore
      isInitial: this.isRevisePage,
      supportingFiles: fileDtos,
      // @ts-ignore
      createSupportingFileStepID: this.supportingFileStepID,
    };
  };
}
